import React, { Fragment, useEffect, useState, useRef } from "react";
import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  tableCellClasses,
  CircularProgress,
  Grid,
  Checkbox,
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  ListItemText,
  Tooltip,
} from "@mui/material";
import styled from "@emotion/styled";
import { FontFamily } from "assets";
import Colors from "assets/Style/Colors";
import { CircleLoading } from "components/Loaders";
import { ErrorToaster } from "components/Toaster";
import { makeStyles } from "@mui/styles";

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { CommaSeparator, Debounce } from "utils";
import SelectField from "components/Select";
import { useDispatch } from "react-redux";
import VehiclePaymentServices from "services/VehiclePayment";
import CustomerServices from "services/Customer";
import { PrimaryButton } from "components/Buttons";
import moment from "moment";
// import ExcelJS from "exceljs";
// import { saveAs } from "file-saver";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowDownwardIcon from "@mui/icons-material/ArrowDownward";
import FinanceServices from "services/Finance";
import { PDFExport } from "@progress/kendo-react-pdf";
import DatePicker from "components/DatePicker";
import PDF from "components/Pdf/PDF";
import SystemServices from "services/System";

// *For Table Style
const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    padding: "15px",
    textAlign: "center",
    whiteSpace: "nowrap",
    background: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "center",
    textWrap: "nowrap",
    padding: "5px !important",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

const useStyles = makeStyles({
  loaderWrap: {
    display: "flex",
    height: 100,
    "& svg": {
      width: "40px !important",
      height: "40px !important",
    },
  },
});

function VehicleSOAList(props) {
  const printMode = !!(props && props.printMode);
  const printCustomerId = props && props.printCustomerId;
  const printCustomerName = props && props.printCustomerName;
  const printCustomerRefId = props && props.printCustomerRefId;
  const printCustomerPhone = props && props.printCustomerPhone;
  const printFromDate = props && props.printFromDate;
  const printToDate = props && props.printToDate;

  const tableRef = useRef(null);

  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const contentRef = useRef(null);

  const [selectedStatus, setSelectedStatus] = useState("All");
  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm();
  const tableHead = [
    "Sr.No",
    // "Nature",
    "Buyer ID",
    "Buy Date",
    "Model",
    "Make",
    "LOT",
    "VIN",
    "Color",
    "Vehicle Amount",
    "Other Charges",
    "Paid",
    "Balance",
    "Past Due Days",
  ];
  const [pdfClient, setPdfClient] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);

  useEffect(() => {
    if (selectedCustomer) {
      setPdfClient(selectedCustomer);

    }
  }, [selectedCustomer]);
const pdfTableHead = [
  "Buyer ID",
  "Purchased",
  "Model/Make/Color",
  "LOT",
  "VIN",
  "Vehicle Amount",
  "Other Charges",
  "Paid",
  "Balance",
  "Past Due Days",
];
  // const handleExportWithComponent = () => {
  //   const pdfTableHead = tableHead?.filter((item) => item !== "Action");
  //   const htmlContent = CreatePdf(
  //     pdfTableHead,
  //     filteredData,
  //     "Vehicle Statement Of Account",
  //     dueBreakup,
  //     "",
  //     totalBalance,
  //     totalPaid,
  //     shippingVault,
  //     "",
  //     vehicleVault,
  //     "",
  //     otherCharges,
  //     totalVehicleAmount,
  //     TotalBalance,
  //     "",
  //     fromDate,
  //     toDate,
  //     selectedStatus,
  //     pdfClient
  //   );
  //   downloadPDF(htmlContent, "Vehicle Soa", filteredData);
  // };
  const [visibleColumns, setVisibleColumns] = useState([
    ...Array(tableHead?.length).keys(),
  ]);
  const [isPDFExport, setIsPDFExport] = useState(false);

  const [loader, setLoader] = useState(false);

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const [pageLimit, setPageLimit] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);

  // *For Filters
  const [filters, setFilters] = useState({});

  // *For Customer Booking
  const [customers, setCustomers] = useState([]);

  const [shippingVault, setShippingVault] = useState();
  const [vehicleVault, setVehicleVault] = useState();
  const [totalVehicleWallet, setTotalVehicleWallet] = useState(0);

  const [totalVehicleAmount, setTotalVehicleAmount] = useState();

  const [otherCharges, setOtherCharges] = useState();

  const [totalPaid, setTotalPaid] = useState();
  const [totalBalance, setTotalBalance] = useState();
  const [exchangeRateAed, setExchangeRateAed] = useState(0);
  const [exchangeRateUsd, setExchangeRateUsd] = useState(0);
  const [vehicleSoaData, setVehicleSoaData] = useState([])
  // Captures any /invoices fetch error during print mode so the kendo export
  // can short-circuit and report it via window.__SOA_ERROR__ to the cron.
  const [printFetchError, setPrintFetchError] = useState(null);
  // *For Tooltip
  const [copied, setCopied] = useState(false);

  const copyContent = (text) => {
    const contentToCopy = text;
    navigator.clipboard.writeText(contentToCopy);
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 300);
  };

  // *For Vehicle SOA
  const [vehicleSoa, setVehicleSoa] = useState();
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const getCurrencies = async () => {
    try {
      let params = {
        detailed: true,
      };
      const { data } = await SystemServices.getCurrencies(params);
      setExchangeRateAed(
        parseFloat(
          data?.currencies.find((e) => e.currency === 'aed')?.conversion_rate
        )
      );
      setExchangeRateUsd(
        parseFloat(
          data?.currencies.find((e) => e.currency === 'usd')?.conversion_rate
        )
      );
    } catch (error) {
      ErrorToaster(error);
    }
  };
  // *For Total Amounts
  // let TotalVehicleAmount = 0
  let TotalOtherCharges = 0;
  let TotalPaidAmount = 0;
  let TotalBalance = 0;

  // *For Get Customer Booking

  const getCustomerBooking = async (search) => {
    try {
      let params = {
        name: search ?? "",
      };
      const { data } = await CustomerServices.getCustomerBooking(params);
      setCustomers(data?.customers);
    } catch (error) {
      ErrorToaster(error);
    }
  };
  useEffect(() => {
    getVehicleSOAUpdate(1, "", { customer_id: selectedCustomer?.id })

  }, [selectedCustomer])
  const getVehicleSOAUpdate = async (page, limit, filter) => {
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: 1,
       limit: 10000,
      };
      params = { ...params, ...Filter };
      const {
        data: { approvals },
      } = await VehiclePaymentServices.getInvoiceList(params);
      setVehicleSoaData(approvals?.rows);
    } catch (error) {
      console.log('error', error);
    }
  }
  // *For Get Vehicle SOA
  const getVehicleSOA = async (page, limit, filter, status) => {
    setLoader(true);
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: 1,
        limit: 10000,
        from_date_soa: toDateOnly(fromDate),
        to_date_soa: toDateOnly(toDate),
      };
      params = { ...params, ...Filter };
      if (printMode) {
        // eslint-disable-next-line no-console
        console.log(
          "[print/vehicle] /invoices request params:",
          JSON.stringify(params),
        );
      }
      const {
        data: { approvals },
      } = await VehiclePaymentServices.getInvoiceList(params);
      if (printMode) {
        // eslint-disable-next-line no-console
        console.log(
          "[print/vehicle] /invoices response:",
          "rows=",
          approvals?.rows?.length || 0,
          "count=",
          approvals?.count,
          "firstRowKeys=",
          approvals?.rows?.[0] ? Object.keys(approvals.rows[0]).join(",") : "(none)",
        );
      }
      setVehicleSoa(approvals?.rows);
      setFilteredData(approvals?.rows);
      const TotalValue = approvals?.rows?.reduce(
        (total, invoice) => total + parseFloat(invoice?.booking?.currency === 'cad' ? invoice?.booking?.value * invoice?.booking_rate / exchangeRateUsd : invoice.booking?.value),
        0
      );
      const TotalOtherCharges = approvals?.rows?.reduce(
        (total, invoice) => total + parseFloat(invoice?.booking?.currency === 'cad' ? invoice?.booking?.other_charges * invoice?.booking_rate / exchangeRateUsd : invoice.booking?.other_charges),
        0
      );
      const TotalPaid = approvals?.rows?.reduce(
        (total, invoice) => total + parseFloat(invoice?.booking?.currency === 'cad' ? invoice?.paid * invoice?.booking_rate / exchangeRateUsd : invoice?.paid),
        0
      );
      const TotalBalance = approvals?.rows?.reduce(
        (total, invoice) => total + parseFloat(invoice?.booking?.currency === 'cad' ? (invoice?.balance * invoice?.booking_rate / exchangeRateUsd) : invoice?.balance),
        0
      );
      setTotalBalance(TotalBalance);
      setOtherCharges(TotalOtherCharges);
      setTotalVehicleAmount(TotalValue);
      setTotalPaid(TotalPaid);
      setTotalCount(approvals?.count);
    } catch (error) {
      ErrorToaster(error);
      // In print mode, the toaster is invisible to anyone — record the
      // failure so the export useEffect can surface it as window.__SOA_ERROR__
      // instead of silently producing an empty PDF.
      if (printMode) {
        setPrintFetchError(
          (error && (error.message || error.response?.data?.message)) ||
            String(error),
        );
      }
    } finally {
      setLoader(false);
    }
  };

  // *For Handle Filter
  const handleFilter = () => {
    if (fromDate && toDate) {
      Debounce(() => {
        getVehicleSOA(1, "", { customer_id: selectedCustomer?.id, status: selectedStatus?.id });
        getVaultDashboard(1, "", { customer_id: selectedCustomer?.id });
      });
      // filterData();
      // Fire the SOA cron pipeline for this customer in the background
      // (renders the cron-style PDF and sends a WhatsApp test message).
      triggerSoaTestSend();
    }
  };

  // Test the SOA cron flow end-to-end for the currently selected customer.
  // Silent: failures are console.error only, no toaster — per product spec.
  const triggerSoaTestSend = async () => {
    if (!selectedCustomer?.id) return;
    try {
      await SystemServices.runSoaTest({
        customer_id: selectedCustomer.id,
        soa_type: "vehicle",
        test_phone: "+923480009821",
        send_whatsapp: true,
      });
    } catch (err) {
      console.error("[soa-test/vehicle]", err);
    }
  };

  // *For Get Vault Dashboard
  const getVaultDashboard = async (page, limit, filter) => {
    setLoader(true);
    try {
      const Page = page ? page : currentPage;
      const Limit = limit ? limit : pageLimit;
      const Filter = { ...filters, ...filter };
      setCurrentPage(Page);
      setPageLimit(Limit);
      setFilters(Filter);
      let params = {
        page: Page,
        limit: Limit,
      };
      params = { ...params, ...Filter };
      const {
        data: { detail },
      } = await FinanceServices.getVehicleSumLedger(params);
      console.log("detail", detail);
      setShippingVault(
        detail?.rows[0].accounts?.find(
          (account) =>
            account.type_code === "L2" && account.primary_series === 50005
        )
      );
      const vehicleWallet = detail?.rows[0].accounts?.find(
        (account) =>
          account.type_code === "L2" && account.primary_series === 50004
      )
      setVehicleVault(vehicleWallet);
      setTotalVehicleWallet(vehicleWallet?.nature === "credit" ? parseFloat(vehicleWallet?.total_credit - vehicleWallet?.total_debit) : parseFloat(vehicleWallet?.total_debit - vehicleWallet?.total_credit))
      setTotalCount(detail?.count);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setLoader(false);
    }
  };
  // Handle downloading
  const handlePdfExport = () => {
    setIsGeneratingPdf(true);
    setTimeout(() => {
      handleExportWithComponent(contentRef);
      setIsGeneratingPdf(false);
    }, 0);
  };

  const toDateOnly = (d) => (d ? moment(d).format("YYYY-MM-DD") : undefined);

  // Handle Date Filter
  // In print mode: backend can pass from_date/to_date in URL; default to a
  // wide window (2025-01-01 → today) so the cron PDF covers the full SOA
  // period instead of the live page's 1-month default.
  const [fromDate, setFromDate] = useState(() => {
    if (printMode) {
      return printFromDate
        ? moment(printFromDate).startOf("day").toDate()
        : moment("2025-01-01").startOf("day").toDate();
    }
    const today = new Date();
    const oneMonthPast = new Date();
    oneMonthPast.setMonth(today.getMonth() - 1);
    return oneMonthPast;
  });
  const [toDate, setToDate] = useState(() =>
    printMode && printToDate
      ? moment(printToDate).endOf("day").toDate()
      : new Date(),
  );
  const [filteredData, setFilteredData] = useState([]);
  const [allsums, setAllSums] = useState(0);
  const netDueTotal = () => {
    setAllSums(
      CommaSeparator(
        parseFloat(
          parseFloat(totalBalance) -
          parseFloat(
            vehicleVault?.nature === "credit"
              ? isNaN(
                parseFloat(vehicleVault?.total_credit) -
                parseFloat(vehicleVault?.total_debit)
              )
                ? parseFloat(0).toFixed(2)
                : parseFloat(
                  parseFloat(vehicleVault?.total_credit) -
                  parseFloat(vehicleVault?.total_debit)
                ).toFixed(2)
              : isNaN(
                parseFloat(vehicleVault?.total_debit) -
                parseFloat(vehicleVault?.total_credit)
              )
                ? parseFloat(0).toFixed(2)
                : parseFloat(
                  parseFloat(vehicleVault?.total_debit) -
                  parseFloat(vehicleVault?.total_credit)
                )
          )
        ).toFixed(2)
      )
    );
  };
  const handleFromDate = (date) => {
    setFromDate(date);
  };

  const handleToDate = (date) => {
    setToDate(date);
    netDueTotal();
  };
  // useEffect(() => {
  //   filterData();
  // }, [fromDate, toDate, vehicleSoa, selectedStatus, vehicleSoaData]);
  useEffect(() => {
    getCurrencies()
    netDueTotal();
  }, [
    fromDate,
    toDate,
    vehicleSoa,
    selectedStatus,
    vehicleVault,
    TotalBalance,
    allsums,
    filteredData,
  ]);
  // const filterData = () => {
  //   if (!vehicleSoaData || !Array.isArray(vehicleSoaData)) {
  //     console.error("vehicleSoa is not properly initialized.");
  //     return;
  //   }
  //   let filteredData = vehicleSoaData;
  //   netDueTotal();

  //   // Handle date range filtering
  //   if (fromDate && toDate) {
  //     const formattedFromDate = moment(fromDate).format("YYYY-MM-DD");
  //     const formattedToDate = moment(toDate).format("YYYY-MM-DD");

  //     filteredData = filteredData?.filter((item) => {
  //       const purchaseDate = moment(item?.booking?.purchase_date).format(
  //         "YYYY-MM-DD"
  //       );
  //       return (
  //         purchaseDate >= formattedFromDate && purchaseDate <= formattedToDate
  //       );
  //     });
  //     setFilteredData(filteredData);
  //   }
  //   if (!fromDate || !toDate) {
  //     setFilteredData([]);
  //   }

  //   // Handle status filtering
  //   if (selectedStatus) {
  //     switch (selectedStatus.name) {
  //       case "UnPaid":
  //         filteredData = filteredData?.filter(
  //           (item) => item && parseFloat(item?.paid) === 0
  //         );
  //         break;
  //       case "Paid":
  //         filteredData = filteredData?.filter(
  //           (item) =>
  //             item && parseFloat(item?.paid) >= parseFloat(item?.balance)
  //         );
  //         break;
  //       case "Partial":
  //         filteredData = filteredData?.filter(
  //           (item) =>
  //             item &&
  //             parseFloat(item?.paid) > 0 &&
  //             parseFloat(item?.paid) < parseFloat(item?.balance)
  //         );
  //         break;
  //       case "All":
  //         // No need to filter, keep all data
  //         break;
  //       default:
  //         // If none of the specific statuses match, keep all data
  //         break;
  //     }
  //     setFilteredData(filteredData);
  //   }
  //   if (!selectedStatus) {
  //     setFilteredData([]);
  //   }
  // };

  // const downloadExcel = () => {
  //   // Define headers and data separately
  //   const headers = tableHead;
  //   const data = vehicleSoa;

  //   // Extract values from objects and create an array for each row
  //   const rows = data.map((item, index) => [
  //     index + 1,
  //     item?.booking?.buyer?.name || "", // Handle optional chaining for potential undefined values
  //     moment(item?.created_at).format("DD-MM-YYYY") || "",
  //     item?.booking?.veh_model?.name || "",
  //     item?.booking?.veh_make?.name || "",
  //     item?.booking?.lot_number || "",
  //     item?.booking?.vin || "",
  //     item?.booking?.color || "",
  //     parseFloat(item?.booking?.value).toFixed(2) || "",
  //     parseFloat(item?.booking?.other_charges).toFixed(2) || "",
  //     parseFloat(item?.paid).toFixed(2) || "",
  //     parseFloat(item?.balance).toFixed(2) || "",
  //     moment().diff(item?.created_at, "days") || "",
  //   ]);
  //   const totalRow = [
  //     "",
  //     "",
  //     "",
  //     "Total",
  //     "",
  //     "",
  //     "",
  //     "",
  //     parseFloat(totalVehicleAmount).toFixed(2),
  //     parseFloat(otherCharges).toFixed(2),
  //     parseFloat(totalPaid).toFixed(2),
  //     parseFloat(totalBalance).toFixed(2),
  //     "",
  //   ];

  //   // Create a workbook with a worksheet
  //   const ws = XLSX.utils.aoa_to_sheet([headers, ...rows, totalRow]);
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

  //   // Convert the workbook to an array buffer
  //   const buf = XLSX.write(wb, {
  //     bookType: "xlsx",
  //     type: "array",
  //     mimeType:
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   // Save the file using FileSaver.js
  //   saveAs(new Blob([buf]), "data.xlsx");
  // };

  const sortData = (e, type, item) => {
    e.preventDefault();
    console.log("Original array:", vehicleSoa);
    console.log(type);
    console.log(item, "item");

    if (type === "ascending" && item == "Buyer ID") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return a.booking?.buyer?.name.localeCompare(b.booking?.buyer?.name);
      });

      setVehicleSoa(sortedData);
    }

    if (type === "descending" && item == "Buyer ID") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return b.booking?.buyer?.name.localeCompare(a.booking?.buyer?.name);
      });

      setVehicleSoa(sortedData);
    }

    if (type === "ascending" && item == "Model") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        console.log(a, b);
        return a.booking?.veh_model?.name.localeCompare(
          b.booking?.veh_model?.name
        );
      });

      setVehicleSoa(sortedData);
    }

    if (type === "descending" && item == "Model") {
      console.log("deefgghe");
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return b.booking?.veh_model?.name.localeCompare(
          a.booking?.veh_model?.name
        );
      });

      setVehicleSoa(sortedData);
    }
    if (type === "ascending" && item == "Make") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        console.log(a, b);
        return a.booking?.veh_make?.name.localeCompare(
          b.booking?.veh_make?.name
        );
      });

      setVehicleSoa(sortedData);
    }
    if (type === "descending" && item == "Make") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return b.booking?.veh_make?.name.localeCompare(
          a.booking?.veh_make?.name
        );
      });

      setVehicleSoa(sortedData);
    }

    if (type === "ascending" && item === "LOT") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        const costA = parseFloat(a.booking?.lot_number) || 0;
        const costB = parseFloat(b.booking?.lot_number) || 0;
        console.log(costA, costB); // Add this line for debugging
        return costA - costB;
      });

      setVehicleSoa(sortedData);
    }
    if (type === "descending" && item === "LOT") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        const costA = parseFloat(a.booking?.lot_number) || 0;
        const costB = parseFloat(b.booking?.lot_number) || 0;
        console.log(costA, costB); // Add this line for debugging
        return costB - costA;
      });

      setVehicleSoa(sortedData);
    }

    if (type === "ascending" && item == "VIN") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        console.log(a, b);
        return a.booking?.vin.localeCompare(b.booking?.vin);
      });

      setVehicleSoa(sortedData);
    }

    if (type === "descending" && item == "VIN") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return b.booking?.vin.localeCompare(a.booking?.vin);
      });

      setVehicleSoa(sortedData);
    }

    if (type === "ascending" && item == "Color") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        console.log(a, b);
        return a.booking?.color.localeCompare(b.booking?.color);
      });

      setVehicleSoa(sortedData);
    }

    if (type === "descending" && item == "Color") {
      const sortedData = [...vehicleSoa].sort((a, b) => {
        // Use the localeCompare method for string comparison
        return b.booking?.color.localeCompare(a.booking?.color);
      });

      setVehicleSoa(sortedData);
    }
  };

  const handleColumnChange = (event) => {
    const selectedColumns = event.target.value;
    // Sort the selected columns to maintain the correct order
    const sortedColumns = selectedColumns.sort((a, b) => a - b);
    setVisibleColumns(sortedColumns);
  };

  const renderCellContent = (colIndex, item, isActive, index) => {
    TotalOtherCharges += parseFloat(item?.booking?.other_charges);
    TotalPaidAmount += parseFloat(item?.paid);
    TotalBalance += parseFloat(item?.balance);
    switch (colIndex) {
      case 0:
        return index + 1;
      case 1:
        return item?.booking?.buyer?.name ?? "-";
      case 2:
        return moment(item?.booking?.purchase_date).format("DD-MM-YYYY");
      case 3:
        return (
          <Box>
            <Tooltip
              className="pdf-hide"
              title={item?.booking?.veh_model?.name ?? "-"}
              arrow
              placement="top"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [10, -2],
                      },
                    },
                  ],
                },
              }}
            >
              {item?.booking?.veh_model?.name?.length > 12
                ? item?.booking?.veh_model?.name?.slice(0, 8) + "..."
                : item?.booking?.veh_model?.name}
            </Tooltip>
            <Box
              component={"div"}
              className="pdf-show"
              sx={{ display: "none !important" }}
            >
              {item?.booking?.veh_model?.name ?? "-"}
            </Box>
          </Box>
        );
      // item?.booking?.veh_model?.name ?? "-";
      case 4:
        return (
          <Box>
            <Tooltip
              className="pdf-hide"
              title={item?.booking?.veh_make?.name ?? "-"}
              arrow
              placement="top"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [10, -2],
                      },
                    },
                  ],
                },
              }}
            >
              {item?.booking?.veh_make?.name?.length > 12
                ? item?.booking?.veh_make?.name?.slice(0, 8) + "..."
                : item?.booking?.veh_make?.name}
            </Tooltip>
            <Box
              component={"div"}
              className="pdf-show"
              sx={{ display: "none !important" }}
            >
              {item?.booking?.veh_make?.name ?? "-"}
            </Box>
          </Box>
        );
      // item?.booking?.veh_make?.name ?? "-";
      case 5:
        return (
          <Box>
            <Tooltip
              className="pdf-hide"
              title={copied ? "copied" : item?.booking?.lot_number ?? "-"}
              arrow
              placement="top"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [10, -2],
                      },
                    },
                  ],
                },
              }}
              onClick={() => copyContent(item?.booking?.lot_number ?? "-")}
            >
              {item?.booking?.lot_number?.length > 12
                ? item?.booking?.lot_number?.slice(0, 8) + "..."
                : item?.booking?.lot_number}
            </Tooltip>
            <Box
              component={"div"}
              className="pdf-show"
              sx={{ display: "none !important" }}
            >
              {item?.booking?.lot_number ?? "-"}
            </Box>
          </Box>
        );
      // item?.booking?.lot_number ?? "-";
      case 6:
        return (
          <Box>
            <Tooltip
              className="pdf-hide"
              title={copied ? "copied" : item?.booking?.vin ?? "-"}
              arrow
              placement="top"
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [10, -2],
                      },
                    },
                  ],
                },
              }}
              onClick={() => copyContent(item?.booking?.vin ?? "-")}
            >
              {item?.booking?.vin?.length > 12
                ? item?.booking?.vin?.slice(0, 8) + "..."
                : item?.booking?.vin}
            </Tooltip>
            <Box
              component={"div"}
              className="pdf-show"
              sx={{ display: "none !important" }}
            >
              {item?.booking?.vin ?? "-"}
            </Box>
          </Box>
        );
      // item?.booking?.vin ?? "-";
      case 7:
        return item?.booking?.color ?? "-";
      case 8:
        return (
          <b>${CommaSeparator(parseFloat(item?.booking?.currency === 'cad' ? item?.booking?.value * item?.booking_rate / exchangeRateUsd : item?.booking?.value).toFixed(2))} </b>
        );
      case 9:
        return (
          <b>
            {" "}
            $
            {CommaSeparator(
              parseFloat(item?.booking?.currency === 'cad' ? item?.booking?.other_charges * item?.booking_rate / exchangeRateUsd : item?.booking?.other_charges).toFixed(2)
            )}
          </b>
        );
      case 10:
        return <b> ${CommaSeparator(parseFloat(item?.booking?.currency === 'cad' ? item?.paid * item?.booking_rate / exchangeRateUsd : item?.paid).toFixed(2))}</b>;
      case 11:
        return <b> ${CommaSeparator(parseFloat(item?.booking?.currency === 'cad' ? item?.balance * item?.booking_rate / exchangeRateUsd : item?.balance).toFixed(2))}</b>;
      case 12:
        return moment().diff(item?.created_at, "days") + "Days";

      default:
        return "-";
    }
  };

  useEffect(() => {
    getCustomerBooking();
  }, []);

  // Due Break up
  const getDateDifference = (date1, date2) => {
    const diffTime = Math.abs(date2 - date1);
    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };
  const calculateDueBreakup = () => {
    const below7Days = filteredData?.filter(
      (item) =>
        getDateDifference(new Date(item.created_at), new Date()) <= 7
    );

    const below8To14Days = filteredData?.filter(
      (item) =>
        getDateDifference(new Date(item.created_at), new Date()) >
        7 && getDateDifference(new Date(item.created_at), new Date()) <= 14
    );
    const over15Days = filteredData?.filter(
      (item) =>
        getDateDifference(new Date(item.created_at), new Date()) > 14
    );

    const below7DaysTotal = below7Days?.reduce(
      (acc, curr) => acc + parseFloat(curr.balance),
      0
    );
    const below8To14DaysTotal = below8To14Days?.reduce(
      (acc, curr) => acc + parseFloat(curr.balance),
      0
    );

    const over15DaysTotal = over15Days?.reduce(
      (acc, curr) => acc + parseFloat(curr.balance),
      0
    );

    return {
      below7DaysTotal,
      below8To14DaysTotal,
      over15DaysTotal,
      total: below7DaysTotal + below8To14DaysTotal + over15DaysTotal,
    };
  };

  const dueBreakup = calculateDueBreakup();
  const handleExportWithComponent = () => {
    if (contentRef.current) {
      contentRef.current.save();
    }
  };

  // ─── PRINT MODE (Vehicle SOA WhatsApp cron) ──────────────────────────────
  // Vehicle's customer dropdown is search-based, so the backend passes
  // name + ref_id explicitly — synthesize selectedCustomer from URL params,
  // fire data fetches with status="false" (unpaid only), and trigger kendo
  // export when data lands. Mirrors the ShippingSOAV2 print path.
  useEffect(() => {
    if (!printMode) return;
    if (selectedCustomer) return;
    if (!printCustomerId) return;
    setSelectedCustomer({
      id: Number(printCustomerId),
      name: printCustomerName || "",
      ref_id: printCustomerRefId || "",
      uae_phone: printCustomerPhone || "",
    });
    setSelectedStatus({ id: "false", name: "UnPaid" });
  }, [
    printMode,
    printCustomerId,
    printCustomerName,
    printCustomerRefId,
    printCustomerPhone,
    selectedCustomer,
  ]);

  // Once selectedCustomer is set in print mode AND currencies have loaded,
  // fire the data fetches. The currency wait matters because getVehicleSOA's
  // totals reduce divides by exchangeRateUsd for CAD invoices — calling
  // before getCurrencies() resolves produces NaN/Infinity totals and an
  // empty-looking PDF.
  useEffect(() => {
    if (!printMode) return;
    if (!selectedCustomer) return;
    if (!exchangeRateUsd) return;
    // eslint-disable-next-line no-console
    console.log(
      "[print/vehicle] firing data fetches for customer",
      selectedCustomer.id,
      "rate=",
      exchangeRateUsd,
    );
    getVehicleSOA(1, "", {
      customer_id: selectedCustomer.id,
      status: "false",
    });
    getVaultDashboard(1, "", { customer_id: selectedCustomer.id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [printMode, selectedCustomer, exchangeRateUsd]);

  // Print-mode kendo export: once data loads, run drawDOM + exportPDF on the
  // PDFExport's wrapped div (same pipeline the live "Download PDF" uses) and
  // stash the data URI on window.__SOA_PDF_DATA_URI__ for puppeteer to read.
  // Wait for BOTH the invoice list AND the ledger (vault) call to complete —
  // the PDF's "Net Due Total" / "Shipping Wallet" / "Vehicle Wallet" rows
  // come from the ledger, and firing the export before they land produces
  // $0.00 wallet rows.
  useEffect(() => {
    if (!printMode) return;
    // Surface any /invoices fetch failure immediately — don't render an
    // empty PDF on top of a real error.
    if (printFetchError) {
      window.__SOA_ERROR__ = `Vehicle SOA fetch failed: ${printFetchError}`;
      window.__SOA_READY__ = true;
      return;
    }
    if (loader) return;
    if (!filteredData) return;
    if (shippingVault === undefined || vehicleVault === undefined) return;

    let cancelled = false;
    const expectedRowCount = Array.isArray(filteredData)
      ? filteredData.length
      : 0;
    // Wait until the kendo subtree has the expected number of <tr> rows
    // before exporting — drawDOM running before MUI/emotion paints leaves
    // empty cells in the PDF. Polls every 150ms up to ~10s.
    const waitForRows = async (rootEl) => {
      const start = Date.now();
      while (Date.now() - start < 10000) {
        const rows = rootEl.querySelectorAll("tbody tr");
        if (rows.length >= expectedRowCount) return;
        await new Promise((r) => setTimeout(r, 150));
      }
    };
    const t = setTimeout(async () => {
      if (cancelled) return;
      if (!contentRef.current) {
        window.__SOA_ERROR__ = "PDFExport ref not mounted (vehicle)";
        window.__SOA_READY__ = true;
        return;
      }
      try {
        const rootEl = contentRef.current.rootElForPDF;
        if (!rootEl) {
          throw new Error("PDFExport rootElForPDF not mounted (vehicle)");
        }
        await waitForRows(rootEl);
        if (cancelled) return;
        const drawing = await import("@progress/kendo-drawing");
        // Mirror what kendo's KendoDrawingAdapter.savePDF does internally:
        // pass options to BOTH drawDOM and exportPDF (and crucially
        // multiPage:true on exportPDF). Skipping pdfOptions made the live
        // page's flex layout collapse in the cron-rendered output.
        const drawOpts = {
          paperSize: "a4",
          landscape: true,
          keepTogether: ".bottom-box",
          margin: { bottom: 80 },
        };
        const pdfOpts = {
          paperSize: "a4",
          landscape: true,
          margin: { bottom: 80 },
          multiPage: true,
        };
        const group = await drawing.drawDOM(rootEl, drawOpts);
        const dataURI = await drawing.exportPDF(group, pdfOpts);
        if (cancelled) return;
        // Expose the same totals the PDF renders so the WhatsApp body
        // (payable + unpaid count) matches the PDF instead of relying on
        // a separate backend SQL query.
        window.__SOA_PDF_DATA_URI__ = dataURI;
        window.__SOA_PAYABLE__ = Number(totalBalance) || 0;
        window.__SOA_UNPAID_COUNT__ = Array.isArray(filteredData)
          ? filteredData.length
          : 0;
        window.__SOA_READY__ = true;
      } catch (e) {
        console.error("[print/vehicle] kendo export failed:", e);
        window.__SOA_ERROR__ = (e && e.message) || String(e);
        window.__SOA_READY__ = true;
      }
    }, 2500);
    return () => {
      cancelled = true;
      clearTimeout(t);
    };
  }, [printMode, loader, filteredData, shippingVault, vehicleVault, printFetchError]);

  if (printMode) {
    if (
      !selectedCustomer ||
      loader ||
      !filteredData ||
      shippingVault === undefined ||
      vehicleVault === undefined
    ) {
      return (
        <Box
          id="soa-print-loading"
          sx={{ p: 4, fontFamily: "Arial, sans-serif" }}
        >
          Loading Vehicle SOA…
        </Box>
      );
    }
    return (
      // Match the live page's wrapper structure exactly — no offscreen
      // positioning. Putting the wrapper at -99999px makes the Box
      // shrink-to-fit, which collapses the inner flex children (e.g.
      // "Generated on:" + date) to two lines instead of one in the PDF.
      // The inner pdf-show display:none keeps the page visually blank.
      <Box>
        <PDFExport
          ref={contentRef}
          paperSize="a4"
          fileName="vehicleSOA"
          dpi={96}
          landscape={true}
          keepTogether=".bottom-box"
          margin={{ bottom: 80 }}
        >
          <Box className="pdf-show" sx={{ display: "none" }}>
            <PDF
              invoiceName="Vehicle Statement Of Account"
              selectedCustomer={selectedCustomer}
              mode="landscape"
              fromdate={fromDate}
              totalBalance={totalBalance}
              todate={toDate}
              tableHead={pdfTableHead}
              resultData={filteredData}
              selectedStatus={selectedStatus}
              shippingVault={shippingVault}
              vehicleVault={vehicleVault}
              totalPaid={totalPaid}
              otherCharges={otherCharges}
              totalVehicleAmount={totalVehicleAmount}
              netBalance={allsums}
              dueBreakup={dueBreakup}
              currencyExchangeRate={exchangeRateUsd}
              netDueTotal={parseFloat(
                totalBalance - totalVehicleWallet / exchangeRateUsd,
              ).toFixed(2)}
            />
          </Box>
        </PDFExport>
      </Box>
    );
  }

  return (
    <Box sx={{ m: 4, mb: 2 }}>
      <Box display={"flex"} justifyContent={"space-between"}>
        <Typography
          variant="h5"
          sx={{
            color: Colors.charcoalGrey,
            fontFamily: FontFamily.NunitoRegular,
            mb: 4,
          }}
        >
          Vehicle SOA
        </Typography>
        {vehicleSoa?.length > 0 && (
          <Box
            sx={{
              textAlign: "right",
              p: 4,
              display: "flex",
              gap: 2,
            }}
          >
            <Box>
              <PDFExport
                ref={contentRef}
                // paperSize={["210mm", "370mm"]}
                paperSize="a4"
                fileName="vehicleSOA"
                dpi={96}
                landscape={true}
                keepTogether=".bottom-box"
                margin={{ bottom: 80 }}
              >
                <Box className="pdf-show" display="none">
                  <PDF
                    invoiceName="Vehicle Statement Of Account"
                    selectedCustomer={selectedCustomer}
                    mode="landscape"
                    fromdate={fromDate}
                    totalBalance={totalBalance}
                    todate={toDate}
                    tableHead={pdfTableHead}
                    resultData={filteredData}
                    selectedStatus={selectedStatus}
                    shippingVault={shippingVault}
                    vehicleVault={vehicleVault}
                    totalPaid={totalPaid}
                    otherCharges={otherCharges}
                    totalVehicleAmount={totalVehicleAmount}
                    netBalance={allsums}
                    dueBreakup={dueBreakup}
                    currencyExchangeRate={exchangeRateUsd}
                    netDueTotal={parseFloat(totalBalance - (totalVehicleWallet / exchangeRateUsd)).toFixed(2)}

                  />
                </Box>
              </PDFExport>
            </Box>
            <PrimaryButton
              title="Download PDF"
              type="button"
              style={{ backgroundColor: Colors.bluishCyan }}
              onClick={() => handleExportWithComponent(contentRef)}
            />
            {/* <PrimaryButton
              title={"Download Excel"}
              onClick={() => downloadExcel()}
            /> */}
          </Box>
        )}
      </Box>
      {/* Filters */}
      <Box
        component={"form"}
        onSubmit={handleSubmit(handleFilter)}
        sx={{
          m: "20px 0 20px 5px",
          p: "20px",
          bgcolor: Colors.feta,
          border: `1px solid ${Colors.iron}`,
          borderRadius: "9px",
        }}
      >
        <Grid container spacing={1} alignItems={"center"}>
          <Grid item xs={12} md={3}>
            <SelectField
              size={"small"}
              onSearch={(v) => getCustomerBooking(v)}
              label={"Select Customer"}
              options={customers}
              selected={selectedCustomer}
              onSelect={(value) => {
                setSelectedCustomer(value);
              }}
              error={errors?.customer?.message}
              register={register("customer", {
                required: "Please select customer.",
              })}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <Controller
              control={control}
              name="selectedStatus"
              // rules={{ required: "Please select status." }}
              render={({ field }) => (
                <SelectField
                  size="small"
                  label={"Status"}
                  options={[
                    { id: 'all', name: "All" },
                    { id: 'true', name: "Paid" },
                    { id: 'false', name: "UnPaid" },
                    // { id: 4, name: "Partial" },
                  ]}
                  selected={field.value}
                  onSelect={(date) => {
                    field.onChange(date);
                    setSelectedStatus(date);
                  }}
                />
              )}
            />
            {errors.selectedStatus && (
              <Typography
                color="error"
                sx={{ fontSize: 12, textAlign: "left" }}
              >
                {errors.selectedStatus.message}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={3}>
            <Controller
              control={control}
              name="fromDate"
              // rules={{ required: "Please select from date." }}
              render={({ field }) => (
                <DatePicker
                  label="From Date"
                  value={fromDate}
                  placeholderText="Select date"
                  maxDate={new Date()}
                  onChange={(date) => {
                    field.onChange(date);
                    handleFromDate(date);
                  }}
                  selected={field.value}
                />
              )}
            />
            {errors.fromDate && (
              <Typography
                color="error"
                sx={{ fontSize: 12, textAlign: "left" }}
              >
                {errors.fromDate.message}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={3}>
            <Controller
              control={control}
              name="toDate"
              // rules={{ required: "Please select to date." }}
              render={({ field }) => (
                <DatePicker
                  label="To Date"
                  value={toDate}
                  minDate={fromDate}
                  maxDate={new Date()}
                  placeholderText="Select date"
                  onChange={(date) => {
                    field.onChange(date);
                    handleToDate(date);
                  }}
                  selected={field.value}
                />
              )}
            />
            {errors.toDate && (
              <Typography
                color="error"
                sx={{ fontSize: 12, textAlign: "left" }}
              >
                {errors.toDate.message}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} md={2}>
            <Box>
              <PrimaryButton loading={loader} type={"submit"} title={"Search"} />
            </Box>
          </Grid>
        </Grid>

      </Box>
      {loader && <CircleLoading />}
      <Grid item md={11}>
        {vehicleSoa && (
          <Box>
            <Grid container mb={2}>
              <Grid item xs={5}>
                <FormControl>
                  <InputLabel>Columns</InputLabel>
                  <Select
                    size={"small"}
                    multiple
                    value={visibleColumns}
                    label={"Columns"}
                    onChange={handleColumnChange}
                    renderValue={() => "Show/Hide"}
                  >
                    {tableHead.map((column, index) => {
                      if (
                        column !== "Vehicle Amount" &&
                        column !== "Other Charges" &&
                        column !== "Paid" &&
                        column !== "Balance" &&
                        column !== "Past Due Days" &&
                        column !== "S.No" &&
                        column !== "Nature"
                      ) {
                        return (
                          <MenuItem key={index} value={index}>
                            <Checkbox
                              checked={visibleColumns.includes(index)}
                            />
                            <ListItemText primary={column} />
                          </MenuItem>
                        );
                      } else {
                        return null;
                      }
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>

            {vehicleSoa && (
              <Fragment>
                <TableContainer
                  component={Paper}
                  sx={{
                    boxShadow: "0px 8px 18px 0px #9B9B9B1A",
                    borderRadius: 2,
                    maxHeight: "calc(100vh - 330px)",
                  }}
                  className="table-box"
                >
                  <Table stickyHeader sx={{ minWidth: 500 }}>
                    {/* Table Header */}
                    <TableHead>
                      <TableRow>
                        {visibleColumns.map((index) => (
                          <Cell className="pdf-table" key={index}>
                            {tableHead[index]}
                            {tableHead[index] == "S.No" ||
                              tableHead[index] == "Past Due Days" ||
                              tableHead[index] == "Buy Date" ||
                              tableHead[index] == "Other Charges" ||
                              tableHead[index] == "Paid" ||
                              tableHead[index] == "Balance" ||
                              tableHead[index] == "Vehicle Amount" ? (
                              ""
                            ) : (
                              <>
                                {" "}
                                <span className="pdf-hide">
                                  <ArrowUpwardIcon
                                    sx={{
                                      color: "white",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) =>
                                      sortData(e, "ascending", tableHead[index])
                                    }
                                  />{" "}
                                </span>
                                <span className="pdf-hide">
                                  {" "}
                                  <ArrowDownwardIcon
                                    sx={{
                                      color: "white",
                                      fontSize: "15px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(e) =>
                                      sortData(
                                        e,
                                        "descending",
                                        tableHead[index]
                                      )
                                    }
                                  />{" "}
                                </span>
                              </>
                            )}
                          </Cell>
                        ))}
                      </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                      {!loader ? (
                        filteredData && filteredData?.length > 0 ? (
                          <Fragment>
                            {filteredData &&
                              filteredData.map((item, rowIndex) => {
                                const isActive = true;
                                return (
                                  <Row
                                    key={rowIndex}
                                    sx={{
                                      bgcolor: rowIndex % 2 !== 0 && "#EFF8E7",
                                    }}
                                  >
                                    {visibleColumns.map((colIndex) => (
                                      <Cell
                                        className="pdf-table"
                                        key={colIndex}
                                      >
                                        {renderCellContent(
                                          colIndex,
                                          item,
                                          isActive,
                                          rowIndex
                                        )}
                                      </Cell>
                                    ))}
                                  </Row>
                                );
                              })}
                            <Row>
                              <Cell colSpan={visibleColumns?.length - 5}>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  Total
                                </Typography>
                              </Cell>
                              <Cell>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  ${" "}
                                  {CommaSeparator(
                                    parseFloat(totalVehicleAmount).toFixed(2)
                                  )}
                                </Typography>
                              </Cell>
                              <Cell>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  ${" "}
                                  {CommaSeparator(
                                    parseFloat(otherCharges).toFixed(2)
                                  )}
                                </Typography>
                              </Cell>
                              <Cell>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  ${" "}
                                  {CommaSeparator(
                                    parseFloat(totalPaid).toFixed(2)
                                  )}
                                </Typography>
                              </Cell>
                              <Cell>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  ${" "}
                                  {CommaSeparator(
                                    parseFloat(totalBalance).toFixed(2)
                                  )}
                                </Typography>
                              </Cell>
                              <Cell></Cell>
                            </Row>
                            <Row>
                              <Cell colSpan={visibleColumns?.length - 5}>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  Net Due Total
                                </Typography>
                              </Cell>

                              <Cell colSpan={4}>
                                <Typography
                                  className="pdf-table"
                                  variant="body1"
                                  sx={{ fontWeight: 700 }}
                                >
                                  ${" "}
                                  {CommaSeparator(parseFloat(totalBalance - (totalVehicleWallet / exchangeRateUsd)).toFixed(2))
                                    // CommaSeparator(
                                    //   parseFloat(
                                    //     parseFloat(totalBalance) -
                                    //       parseFloat(
                                    //         vehicleVault?.nature === "credit"
                                    //           ? isNaN(
                                    //               parseFloat(
                                    //                 vehicleVault?.total_credit
                                    //               ) -
                                    //                 parseFloat(
                                    //                   vehicleVault?.total_debit
                                    //                 )
                                    //             )
                                    //             ? parseFloat(0).toFixed(2)
                                    //             : parseFloat(
                                    //                 parseFloat(
                                    //                   vehicleVault?.total_credit
                                    //                 ) -
                                    //                   parseFloat(
                                    //                     vehicleVault?.total_debit
                                    //                   )
                                    //               ).toFixed(2)
                                    //           : isNaN(
                                    //               parseFloat(
                                    //                 vehicleVault?.total_debit
                                    //               ) -
                                    //                 parseFloat(
                                    //                   vehicleVault?.total_credit
                                    //                 )
                                    //             )
                                    //           ? parseFloat(0).toFixed(2)
                                    //           : parseFloat(
                                    //               parseFloat(
                                    //                 vehicleVault?.total_debit
                                    //               ) -
                                    //                 parseFloat(
                                    //                   vehicleVault?.total_credit
                                    //                 )
                                    //             )
                                    //       )
                                    //   ).toFixed(2)
                                    // )

                                  }
                                </Typography>
                              </Cell>
                              <Cell></Cell>
                            </Row>
                          </Fragment>
                        ) : (
                          <Row>
                            <Cell
                              colSpan={tableHead.length + 1}
                              align="center"
                              sx={{ fontWeight: 600 }}
                            >
                              No Data Found
                            </Cell>
                          </Row>
                        )
                      ) : (
                        <TableRow>
                          <TableCell
                            colSpan={visibleColumns?.length + 2}
                            align="center"
                            sx={{ fontWeight: 600 }}
                          >
                            <Box className={classes.loaderWrap}>
                              <CircularProgress />
                            </Box>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <Box sx={{ py: 1, bgcolor: Colors.whiteSmoke }}>
                  <Grid container spacing={1}>
                    <Grid item xs={12} sm={3}></Grid>

                    <Grid item xs={12} sm={3}></Grid>
                    <Grid item xs={12} sm={3}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Shipping Wallet
                        </Typography>
                        <Box
                          sx={{
                            textAlign: "center",
                            p: 1,
                            width: "130px",
                            bgcolor: Colors.flashWhite,
                            border: "1px solid #B2B5BA",
                            borderRadius: "4px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: Colors.smokeyGrey }}
                          >

                            ${" "}
                            {shippingVault?.nature === "credit"
                              ? isNaN(
                                parseFloat(shippingVault?.total_credit - shippingVault?.total_debit) / exchangeRateUsd
                              )
                                ? parseFloat(0).toFixed(2)
                                : CommaSeparator(
                                  parseFloat((shippingVault?.total_credit - shippingVault?.total_debit) / exchangeRateUsd).toFixed(2)

                                )
                              : isNaN(
                                parseFloat(shippingVault?.total_debit - shippingVault?.total_credit / exchangeRateUsd)
                              )
                                ? parseFloat(0).toFixed(2)
                                :
                                parseFloat(shippingVault?.total_debit - shippingVault?.total_credit / exchangeRateUsd).toFixed(2)
                            }
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} sm={3}>
                      <Box
                        sx={{
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Vehicle Wallet
                        </Typography>
                        <Box
                          sx={{
                            textAlign: "center",
                            p: 1,
                            width: "130px",
                            bgcolor: Colors.flashWhite,
                            border: "1px solid #B2B5BA",
                            borderRadius: "4px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{ color: Colors.smokeyGrey }}
                          >
                            ${" "}
                            {vehicleVault?.nature === "credit"
                              ? isNaN(
                                parseFloat(vehicleVault?.total_credit) -
                                parseFloat(vehicleVault?.total_debit)
                              )
                                ? parseFloat(0).toFixed(2)
                                : CommaSeparator(
                                  parseFloat((vehicleVault?.total_credit - vehicleVault?.total_debit) / exchangeRateUsd).toFixed(2)
                                )
                              : isNaN(
                                parseFloat(vehicleVault?.total_debit) -
                                parseFloat(vehicleVault?.total_credit)
                              )
                                ? parseFloat(0).toFixed(2)
                                : CommaSeparator(
                                  parseFloat(
                                    parseFloat(vehicleVault?.total_debit) -
                                    parseFloat(vehicleVault?.total_credit)
                                  )
                                )}
                          </Typography>
                        </Box>
                      </Box>
                    </Grid>

                    {/* {isGeneratingPdf && (
                      <Grid item xs={12} sm={3}>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            marginLeft: "25.4px",
                          }}
                        >
                          <Typography
                            variant="body2"
                            sx={{
                              fontWeight: 700,
                              fontFamily: "NunitoRegular",
                            }}
                          >
                            Due Break Up
                          </Typography>
                          <Box
                            sx={{
                              display: "flex",
                              gap: "10px",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <Box
                              sx={{
                                textAlign: "center",
                                p: 1,
                                width: "130px",
                                bgcolor: "flashWhite",
                                border: "1px solid #B2B5BA",
                                borderRadius: "4px",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                Below 7 Days
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                ${" "}
                                {CommaSeparator(
                                  parseFloat(
                                    dueBreakup.below7DaysTotal
                                  ).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                textAlign: "center",
                                p: 1,
                                width: "130px",
                                bgcolor: "flashWhite",
                                border: "1px solid #B2B5BA",
                                borderRadius: "4px",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                Below 8-14 Days
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                ${" "}
                                {CommaSeparator(
                                  parseFloat(
                                    dueBreakup.below8To14DaysTotal
                                  ).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                textAlign: "center",
                                p: 1,
                                width: "130px",
                                bgcolor: "flashWhite",
                                border: "1px solid #B2B5BA",
                                borderRadius: "4px",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                Over 15 Days
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                ${" "}
                                {CommaSeparator(
                                  parseFloat(
                                    dueBreakup.over15DaysTotal
                                  ).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                textAlign: "center",
                                p: 1,
                                width: "130px",
                                bgcolor: "flashWhite",
                                border: "1px solid #B2B5BA",
                                borderRadius: "4px",
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                Total
                              </Typography>
                              <Typography
                                variant="body2"
                                sx={{ color: "smokeyGrey" }}
                              >
                                ${" "}
                                {CommaSeparator(
                                  parseFloat(dueBreakup.total).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        </Box>
                      </Grid>
                    )} */}

                    {/* <Grid item xs={12} sm={3}>
                <Box
                  sx={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      fontWeight: 700,
                      fontFamily: FontFamily.NunitoRegular,
                    }}
                  >
                    Net Due Balance 
                  </Typography>
                  <Box
                    sx={{
                      textAlign: "center",
                      p: 1,
                      width: "130px",
                      bgcolor: Colors.flashWhite,
                      border: "1px solid #B2B5BA",
                      borderRadius: "4px",
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                     $ {parseFloat(parseFloat(TotalBalance) - parseFloat(vehicleVault?.nature === 'credit' ? isNaN((parseFloat(vehicleVault?.total_credit) - parseFloat(vehicleVault?.total_debit))) ? parseFloat(0).toFixed(2) :parseFloat( (parseFloat(vehicleVault?.total_credit) - parseFloat(vehicleVault?.total_debit))).toFixed(2) : isNaN((parseFloat(vehicleVault?.total_debit) - parseFloat(vehicleVault?.total_credit))) ? parseFloat(0).toFixed(2) : parseFloat((parseFloat(vehicleVault?.total_debit) - parseFloat(vehicleVault?.total_credit))))).toFixed(2) }
                    </Typography>
                  </Box>
                </Box>
              </Grid> */}
                  </Grid>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-evenly",
                      margin: "8px 0px 8px 0px",
                      fontFamily: FontFamily.NunitoRegular,
                    }}
                  >
                    <Grid item xs={12} md={2}>
                      <Typography
                        variant="body2"
                        sx={{
                          fontWeight: 700,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontFamily: FontFamily.NunitoRegular,
                        }}
                      >
                        Due Break Up
                      </Typography>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Box
                        sx={{
                          textAlign: "center",
                          p: 1,
                          width: "100%",
                          bgcolor: Colors.flashWhite,
                          border: "1px solid #B2B5BA",
                          borderRadius: "4px",
                          fontFamily: FontFamily.NunitoRegular,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Below 7 Days
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.NunitoRegular,
                            fontWeight: 700,
                          }}
                        >
                          ${" "}
                          {CommaSeparator(
                            parseFloat(dueBreakup.below7DaysTotal).toFixed(2)
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Box
                        sx={{
                          textAlign: "center",
                          p: 1,
                          width: "100%",
                          bgcolor: Colors.flashWhite,
                          border: "1px solid #B2B5BA",
                          borderRadius: "4px",
                          fontFamily: FontFamily.NunitoRegular,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Below 8-14 Days
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.NunitoRegular,
                            fontWeight: 700,
                          }}
                        >
                          ${" "}
                          {CommaSeparator(
                            parseFloat(dueBreakup.below8To14DaysTotal).toFixed(
                              2
                            )
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Box
                        sx={{
                          textAlign: "center",
                          p: 1,
                          width: "100%",
                          bgcolor: Colors.flashWhite,
                          border: "1px solid #B2B5BA",
                          borderRadius: "4px",
                          fontFamily: FontFamily.NunitoRegular,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Over 15 Days
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontFamily: FontFamily.NunitoRegular,
                            fontWeight: 700,
                          }}
                        >
                          ${" "}
                          {CommaSeparator(
                            parseFloat(dueBreakup.over15DaysTotal).toFixed(2)
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={2}>
                      <Box
                        sx={{
                          textAlign: "center",
                          p: 1,
                          width: "100%",
                          bgcolor: Colors.flashWhite,
                          border: "1px solid #B2B5BA",
                          borderRadius: "4px",
                          fontFamily: FontFamily.NunitoRegular,
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          Total
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{
                            color: Colors.smokeyGrey,
                            fontWeight: 700,
                            fontFamily: FontFamily.NunitoRegular,
                          }}
                        >
                          ${" "}
                          {CommaSeparator(
                            parseFloat(dueBreakup.total).toFixed(2)
                          )}
                        </Typography>
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                
              </Fragment>
            )}

            {loader && <CircleLoading />}
          </Box>
        )}
      </Grid>
    </Box>
  );
}

export default VehicleSOAList;
